import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { laGrandeConfig } from "./data";

export default function LaGrandePage() {
  return <OregonCityPageTemplate config={laGrandeConfig} />;
}